import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SymptomsSection } from './components/SymptomsSection';
import { WhatIsSection } from './components/WhatIsSection';
import { MethodSection } from './components/MethodSection';
import { TransformationSection } from './components/TransformationSection';
import { AboutSection } from './components/AboutSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FooterSection } from './components/FooterSection';
import { WhatsAppButton } from './components/WhatsAppButton';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-primary selection:bg-accent/30 selection:text-primary" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SymptomsSection data-id="element-5" />
        <WhatIsSection data-id="element-6" />
        <MethodSection data-id="element-7" />
        <TransformationSection data-id="element-8" />
        <AboutSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <FAQSection data-id="element-11" />
      </main>

      <FooterSection data-id="element-12" />
      <WhatsAppButton data-id="element-13" />
    </div>;
}